/* PIKOVA — a story block.

   One job: a film shown small can be opened full screen. On a phone that is
   the difference between a thumbnail and actually seeing the water. */

(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var reel = e.target.closest && e.target.closest('[data-pk-reel]');
    if (!reel) return;

    var film = reel.querySelector('video');
    if (!film) return;

    // iOS gives video its own full-screen route and ignores the standard one
    if (film.webkitEnterFullscreen) film.webkitEnterFullscreen();
    else if (film.requestFullscreen) film.requestFullscreen();
  });
})();
